import React, { useState, useRef } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { closeModal, openModal } from 'features/utilsSlice';
import { setInvitation } from 'features/gigsSlice';
import { MAX_INVITATIONS_COUNT } from 'constants/settings';
import GigInvitationDialog from 'components/gigs/GigInvitationDialog';
import SimpleDialog from 'components/SimpleDialog';

const useStyles = makeStyles({
  root: {
    display: 'flex',
  },
  paper: {
    minWidth: 140,
    maxHeight: 250,
    overflowY: 'auto',
    marginTop: 5,
    marginBottom: 5,
    padding: '5px 10px',
    borderRadius: 10,
    boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.1)',
  },

  popper: {
    zIndex: 11,
  },
});

const GigListDropdown = ({
  menuItems,
  setMenuItems,
  profile,
  handleClick,
  gig,
  fromMatches,
  isDialog,
}) => {
  const [open, setOpen] = useState(false);
  const [openInvite, setOpenInvite] = useState(false);
  const anchorRef = useRef(null);
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleToggle = () => {
    if (fromMatches) {
      handleClick(profile);
    } else if (isEmpty(gig) || !isDialog) {
      setOpen(prevOpen => !prevOpen);
    } else {
      handleClick(profile, gig);
    }
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event?.target)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };

  const handleDialogClose = () => dispatch(closeModal('Gig Limit'));

  const handleItemClick = item => {
    if (item.invitations_count === MAX_INVITATIONS_COUNT && !item.user.partner) {
      return dispatch(openModal({ name: 'Gig Limit' }));
    }

    if (!isDialog) {
      setOpenInvite(true);
      dispatch(openModal({ name: 'Request Gig', data: { gig: item, profile } }));
      dispatch(setInvitation(profile));
    } else {
      handleClick(profile, item);
    }

    handleClose();
  };

  return (
    <div className={classes.root}>
      <Button ref={anchorRef} onClick={handleToggle} color="primary" variant="contained">
        {!isEmpty(gig) || fromMatches ? 'Invite' : 'Invite to gig'}
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        modifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: 'viewport',
          },
        }}
        transition
        disablePortal
        className={classes.popper}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper className={classes.paper}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                  style={{ padding: 0 }}
                >
                  {menuItems.map((item, index) => (
                    <MenuItem onClick={() => handleItemClick(item)} key={index}>
                      {item.title}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      {openInvite && !isDialog && <GigInvitationDialog setMenuItems={setMenuItems} />}
      <SimpleDialog
        modalName="Gig Limit"
        description="You have reached the limit of gig invitations for this gig."
        onClick={handleDialogClose}
        buttonText="Got it"
      />
    </div>
  );
};

export default GigListDropdown;
